import { useCallback, useRef } from 'react';

const openNativePicker = (input) => {
  if (!input) return;
  if (typeof input.showPicker === 'function') {
    input.showPicker();
    return;
  }
  input.focus();
};

const usePickerField = ({
  disabled = false,
  onChange,
  closeOnChange = false,
  shouldAutoAdvance = false,
  autoAdvanceRef = null,
} = {}) => {
  const inputRef = useRef(null);

  const openPicker = useCallback(() => {
    if (disabled) return;
    openNativePicker(inputRef.current);
  }, [disabled]);

  const handleWrapperClick = useCallback(() => {
    openPicker();
  }, [openPicker]);

  const handleChange = useCallback(
    (event) => {
      if (onChange) {
        onChange(event);
      }

      const nextValue = event?.target?.value;
      if (!nextValue) return;

      if (shouldAutoAdvance && autoAdvanceRef?.current) {
        requestAnimationFrame(() => openNativePicker(autoAdvanceRef.current));
        return;
      }

      if (closeOnChange && event?.target) {
        event.target.blur();
      }
    },
    [onChange, shouldAutoAdvance, autoAdvanceRef, closeOnChange],
  );

  return {
    inputRef,
    openPicker,
    handleWrapperClick,
    handleChange,
  };
};

export default usePickerField;
